import getSelectors from '../../shared/store/selectorsFactory';
import { adminPageNames } from '../../shared/adminPageNames';

export const sharedSelectors = getSelectors(adminPageNames.TRIAL_BALANCE_THRESHOLD);

export const connectionNameSelector = state =>
  state.administration[adminPageNames.TRIAL_BALANCE_THRESHOLD].connectionName;

export const connectionNamesSelector = state =>
  state.administration[adminPageNames.TRIAL_BALANCE_THRESHOLD].connectionNames;
